import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-region-rank',
  templateUrl: './region-rank.component.html',
  styleUrl: './region-rank.component.scss'
})
export class RegionRankComponent implements OnInit, OnDestroy {
  constructor(private dashboardService: DashboardService) { }
  @ViewChild('regionRankContainer', { static: false }) regionRankContainer: ElementRef; loading: boolean;
  @Input() username: string;
  noData: boolean;
  periodType:string;
  periodOffset:number;
  regionName:string;
  private unsubscribe$ = new Subject<void>()

  ngOnInit(): void {
    this.dashboardService.regionRankData.pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
      this.dashboardService.removeDomElement('region-rank-content');
      this.noData = result.length === 0;
      if (result && result.length !== 0) {
        result.forEach(element => {
          this.periodOffset = element.periodOffset;
          this.periodType =element.periodType;
          this.regionName = element.regionName;
          if (element.conversionAgainstTarget < 0) {
            element.isNegative = true;
          }
          element.conversion = parseFloat((element.conversion * 100).toFixed(1));
          element.conversionAgainstTarget = Math.abs(parseFloat((element.conversionAgainstTarget * 100).toFixed(1)));
          if (!element.rank) {
            this.noData = true;
            return;
          }
        });
        const container = document.createElement('div');
        container.id = 'region-rank-content';
        if (!container) return;

        const table = document.createElement('table');
        table.style.border = '1';
        table.style.width = '100%';
        table.style.borderCollapse = 'collapse';

        const thead = document.createElement('thead');
        thead.style.boxShadow = '0px 1px 0px 0px #B9B9B9 inset';
        thead.style.background = '#d9f2e3';
        thead.style.backgroundColor = '#dbdbdb';
        thead.style.height = '2rem';

        const headerRow = document.createElement('tr');
        let headers = [];
        if(this.periodType === "WTD" && this.periodOffset === 0){
          headers = ['Rank', 'Name', 'Gap to target(%)', 'CNV(%)'];
        } else {
          headers = ['Rank', 'Name', 'CNV(%)'];
        }
        headers.forEach(headerText => {
          const th = document.createElement('th');
          if(headerText === 'Gap to target(%)'){
            th.style.maxWidth = '4rem';
          }
          th.textContent = headerText;
          th.style.padding = '0.35rem';
          th.style.border = '1px solid #B9B9B9';

          headerRow.appendChild(th);
        });

        thead.appendChild(headerRow);
        table.appendChild(thead);

        const tbody = document.createElement('tbody');
        result.forEach(region => {
          const row = document.createElement('tr');

              Object.entries(region).forEach(([key,value]) => {
            if(headers.length === 3){
              if(key === 'conversionAgainstTarget') return;
            }
            if (key === 'isNegative' || key === 'periodType' || key === 'periodOffset' || key === 'regionName') return;
            const td = document.createElement('td');
            if (region.userName.toLowerCase().trim().replace(' ','') === this.username.toLowerCase().replace('.','')) {
              td.style.fontWeight = '700';
            }
            if (key === 'conversionAgainstTarget') {
              if (region.isNegative) {
                td.style.backgroundColor = '#e7bbb8';
              } else {
                td.style.backgroundColor = '#d9f2e3';
              }
            }
            td.textContent = value;
            td.style.padding = '0.35rem';
            td.style.border = '1px solid #B9B9B9';
            row.appendChild(td);
          });
          tbody.appendChild(row);
        });

        //   Object.values(region).forEach(value => {
        //     if(headers.length === 3){
        //       if(value === region.conversionAgainstTarget) return;
        //     }
        //     if (typeof value === 'boolean' || value === region.periodType || value === region.periodOffset || value === region.regionName) return;
        //     const td = document.createElement('td');
        //     if (region.userName.toLowerCase().trim().replace(' ','') === this.username.toLowerCase().replace('.','')) {
        //       td.style.fontWeight = '700';
        //     }
        //     if (value === region.conversionAgainstTarget) {
        //       if (region.isNegative) {
        //         td.style.backgroundColor = '#e7bbb8';
        //       } else {
        //         td.style.backgroundColor = '#d9f2e3';
        //       }
        //     }
        //     td.textContent = value;
        //     td.style.padding = '0.35rem';
        //     td.style.border = '1px solid #B9B9B9';
        //     row.appendChild(td);
        //   });
        //   tbody.appendChild(row);
        // });

        table.appendChild(tbody);
        container.appendChild(table);

        this.regionRankContainer.nativeElement.appendChild(container);
      }
    })

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}